import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import "semantic-ui-css/components/popup.min.css";

export default class FixedLeftMenu extends Component {
  static propTypes = {
    actions: PropTypes.array,
    location: PropTypes.obj,
    history: PropTypes.obj
  }

  render() {
    return (
      <div className="page__sidebar">
          <ul className="main-sidebar">
            {this.props.actions.map(action => (
                <li className={`main-sidebar__item main-sidebar__item${this.props.location.pathname === action.url ? '_active' : ''}`}>
                  <Popup
                    trigger={
                      <a onClick={() => this.props.history.push(action.url)} className="main-sidebar__link">
                        <svg className={`icon-svg ${action.icon}`} role="img">
                        </svg>
                      </a>
                    }
                    content={action.title}
                    position="right center"
                    inverted
                    size="mini"
                  />
              </li>
            ))}
          </ul>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FixedLeftMenuComponent/FixedLeftMenu.js